const BASE_GEO = {
  "United States of America": 186400,
  China: 142800,
  India: 98200,
  Japan: 61500,
  Germany: 58300,
  "United Kingdom": 54700,
  France: 47100,
  Brazil: 44600,
  Italy: 41200,
  Canada: 39800,
  Russia: 36900,
  "South Korea": 35400,
  Australia: 33100,
  Spain: 31600,
  Mexico: 29400,
  Indonesia: 27800,
  Netherlands: 26200,
  Turkey: 24500,
  "Saudi Arabia": 22100,
  Switzerland: 21400,
  Poland: 28600,
  Sweden: 19800,
  Belgium: 18900,
  Norway: 17200,
  Austria: 16500,
  Romania: 15800,
  "United Arab Emirates": 14600,
  Israel: 14200,
  Thailand: 19400,
  Vietnam: 18700,
  Malaysia: 17900,
  Philippines: 16100,
  Egypt: 15300,
  "South Africa": 14800,
  Argentina: 13900,
  Colombia: 13200,
  Chile: 12400,
  Nigeria: 11800,
  Kenya: 10500,
  Morocco: 9800,
  Portugal: 12900,
  Greece: 11200,
  Czechia: 11600,
  Denmark: 10900,
  Finland: 10200,
  Ireland: 9600,
  "New Zealand": 9100,
  Hungary: 8700,
  Pakistan: 13500,
  Bangladesh: 12000,
};

const GEO_SCALE = {
  exhibition: 1.28,
  grunplege: 0.52,
  mmc: 1.15,
  babysteps: 0.45,
};

const VARIANT_GEO_WEIGHTS = {
  exhibition: {
    "United States of America": 1.55,
    Germany: 1.45,
    France: 1.42,
    "United Kingdom": 1.38,
    Italy: 1.22,
    Spain: 1.18,
    Netherlands: 1.15,
    Canada: 1.12,
    China: 0.42,
    India: 0.38,
    Japan: 0.48,
    Brazil: 0.55,
  },
  grunplege: {
    Germany: 1.62,
    Austria: 1.55,
    Switzerland: 1.48,
    Poland: 1.38,
    Netherlands: 1.22,
    Czechia: 1.28,
    France: 1.12,
    Romania: 1.18,
    "United States of America": 0.48,
    China: 0.45,
    Japan: 0.52,
    Brazil: 0.42,
    Australia: 0.55,
  },
  mmc: {
    "United States of America": 1.68,
    Brazil: 1.45,
    Mexico: 1.42,
    Canada: 1.28,
    Colombia: 1.32,
    Argentina: 1.22,
    Chile: 1.18,
    "United Kingdom": 0.55,
    Germany: 0.52,
    France: 0.5,
    India: 0.48,
    China: 0.45,
    Japan: 0.52,
  },
  babysteps: {
    India: 1.58,
    Japan: 1.42,
    "South Korea": 1.38,
    Vietnam: 1.45,
    Philippines: 1.32,
    Thailand: 1.28,
    Malaysia: 1.25,
    Indonesia: 1.22,
    Bangladesh: 1.18,
    Pakistan: 1.12,
    Germany: 0.42,
    France: 0.45,
    "United Kingdom": 0.48,
    Brazil: 0.52,
    "United States of America": 0.62,
  },
};

const VARIANT_KEYS = ["exhibition", "grunplege", "mmc", "babysteps"];

const ANALYTICS = {
  exhibition: {
    trafficWeek: [
      { name: "Mon", sessions: 512, users: 248 },
      { name: "Tue", sessions: 598, users: 291 },
      { name: "Wed", sessions: 476, users: 212 },
      { name: "Thu", sessions: 621, users: 306 },
      { name: "Fri", sessions: 689, users: 320 },
      { name: "Sat", sessions: 434, users: 190 },
      { name: "Sun", sessions: 401, users: 165 },
    ],
    sources: [
      { name: "Organic", value: 48, color: "#1f77b4" },
      { name: "Direct", value: 26, color: "#ff7f0e" },
      { name: "Referral", value: 14, color: "#2ca02c" },
      { name: "Social", value: 12, color: "#d62728" },
    ],
    devices: [
      { name: "Mobile", sessions: 52 },
      { name: "Desktop", sessions: 38 },
      { name: "Tablet", sessions: 10 },
    ],
    metrics: [
      { key: "sessions", value: "14.2k", trend: 18, labelKey: "metricSessions" },
      { key: "users", value: "3.8k", trend: 11, labelKey: "metricUsers" },
      { key: "bounce", value: "38%", trend: -4, labelKey: "metricBounce" },
      { key: "views", value: "31.4k", trend: 24, labelKey: "metricPageViews" },
    ],
  },
  grunplege: {
    trafficWeek: [
      { name: "Mon", sessions: 298, users: 142 },
      { name: "Tue", sessions: 312, users: 151 },
      { name: "Wed", sessions: 276, users: 128 },
      { name: "Thu", sessions: 305, users: 146 },
      { name: "Fri", sessions: 288, users: 139 },
      { name: "Sat", sessions: 198, users: 94 },
      { name: "Sun", sessions: 176, users: 82 },
    ],
    sources: [
      { name: "Organic", value: 38, color: "#1f77b4" },
      { name: "Direct", value: 35, color: "#ff7f0e" },
      { name: "Referral", value: 17, color: "#2ca02c" },
      { name: "Social", value: 10, color: "#d62728" },
    ],
    devices: [
      { name: "Mobile", sessions: 44 },
      { name: "Desktop", sessions: 46 },
      { name: "Tablet", sessions: 10 },
    ],
    metrics: [
      { key: "sessions", value: "8.1k", trend: 6, labelKey: "metricSessions" },
      { key: "users", value: "2.1k", trend: 4, labelKey: "metricUsers" },
      { key: "bounce", value: "45%", trend: 2, labelKey: "metricBounce" },
      { key: "views", value: "17.8k", trend: 9, labelKey: "metricPageViews" },
    ],
  },
  mmc: {
    trafficWeek: [
      { name: "Mon", sessions: 388, users: 188 },
      { name: "Tue", sessions: 412, users: 201 },
      { name: "Wed", sessions: 401, users: 195 },
      { name: "Thu", sessions: 428, users: 208 },
      { name: "Fri", sessions: 405, users: 198 },
      { name: "Sat", sessions: 242, users: 118 },
      { name: "Sun", sessions: 218, users: 106 },
    ],
    sources: [
      { name: "Organic", value: 42, color: "#1f77b4" },
      { name: "Direct", value: 31, color: "#ff7f0e" },
      { name: "Referral", value: 18, color: "#2ca02c" },
      { name: "Social", value: 9, color: "#d62728" },
    ],
    devices: [
      { name: "Mobile", sessions: 36 },
      { name: "Desktop", sessions: 52 },
      { name: "Tablet", sessions: 12 },
    ],
    metrics: [
      { key: "sessions", value: "11.6k", trend: 9, labelKey: "metricSessions" },
      { key: "users", value: "2.9k", trend: 7, labelKey: "metricUsers" },
      { key: "bounce", value: "42%", trend: 0, labelKey: "metricBounce" },
      { key: "views", value: "24.2k", trend: 12, labelKey: "metricPageViews" },
    ],
  },
  babysteps: {
    trafficWeek: [
      { name: "Mon", sessions: 212, users: 118 },
      { name: "Tue", sessions: 248, users: 132 },
      { name: "Wed", sessions: 236, users: 128 },
      { name: "Thu", sessions: 255, users: 141 },
      { name: "Fri", sessions: 268, users: 146 },
      { name: "Sat", sessions: 304, users: 168 },
      { name: "Sun", sessions: 288, users: 155 },
    ],
    sources: [
      { name: "Organic", value: 32, color: "#1f77b4" },
      { name: "Direct", value: 22, color: "#ff7f0e" },
      { name: "Referral", value: 11, color: "#2ca02c" },
      { name: "Social", value: 35, color: "#d62728" },
    ],
    devices: [
      { name: "Mobile", sessions: 72 },
      { name: "Desktop", sessions: 22 },
      { name: "Tablet", sessions: 6 },
    ],
    metrics: [
      { key: "sessions", value: "6.4k", trend: 22, labelKey: "metricSessions" },
      { key: "users", value: "1.7k", trend: 19, labelKey: "metricUsers" },
      { key: "bounce", value: "36%", trend: -6, labelKey: "metricBounce" },
      { key: "views", value: "14.1k", trend: 28, labelKey: "metricPageViews" },
    ],
  },
};

function hashPlanKey(planId) {
  const s = planId != null && String(planId).length ? String(planId) : "default";
  let h = 0;
  for (let i = 0; i < s.length; i += 1) {
    h = (Math.imul(31, h) + s.charCodeAt(i)) | 0;
  }
  return Math.abs(h);
}

function variantForPlanId(planId) {
  const idx = hashPlanKey(planId) % VARIANT_KEYS.length;
  return VARIANT_KEYS[idx];
}

function cloneBundle(variantKey) {
  const bundle = ANALYTICS[variantKey];
  return {
    trafficWeek: bundle.trafficWeek.map((d) => ({ ...d })),
    sources: bundle.sources.map((d) => ({ ...d })),
    devices: bundle.devices.map((d) => ({ ...d })),
    metrics: bundle.metrics.map((d) => ({ ...d })),
  };
}

function formatKFromNumber(v) {
  if (v >= 1000) {
    const k = v / 1000;
    const s = k >= 10 ? String(Math.round(k)) : k.toFixed(1);
    return `${s.replace(/\.0$/, "")}k`;
  }
  return String(Math.max(0, Math.round(v)));
}

function perturbMetricDisplayString(str, salt) {
  const mult = 0.82 + ((salt >>> 3) % 28) / 100;
  const trimmed = String(str).trim();
  if (/%$/.test(trimmed)) {
    const n = parseInt(trimmed, 10);
    if (Number.isNaN(n)) return str;
    const jitter = (salt % 11) - 5;
    return `${Math.max(20, Math.min(58, n + jitter))}%`;
  }
  const km = trimmed.match(/^([\d.]+)\s*k$/i);
  if (km) {
    const v = parseFloat(km[1]) * 1000 * mult;
    return formatKFromNumber(v);
  }
  return str;
}

function clampTrend(n) {
  return Math.max(-28, Math.min(42, n));
}

function perturbAnalyticsBundle(bundle, planId) {
  const h = hashPlanKey(planId);
  const scale = 0.76 + ((h >>> 8) & 0x3f) / 90;

  const trafficWeek = bundle.trafficWeek.map((d, i) => {
    const w = 1 + (((h + i * 47) % 27) - 13) / 100;
    return {
      ...d,
      sessions: Math.max(1, Math.round(d.sessions * scale * w)),
      users: Math.max(1, Math.round(d.users * scale * w)),
    };
  });

  const sourcesRaw = bundle.sources.map((s, i) => {
    const noise = 1 + (((h + i * 13) % 23) - 11) / 100;
    return { ...s, value: Math.max(1, Math.round(s.value * noise)) };
  });
  const srcSum = sourcesRaw.reduce((a, s) => a + s.value, 0);
  const sources = sourcesRaw.map((s) => ({
    ...s,
    value: Math.round((s.value / srcSum) * 100),
  }));
  const srcRoundDiff =
    100 - sources.reduce((a, s) => a + s.value, 0);
  if (sources.length) sources[0].value += srcRoundDiff;

  const devicesRaw = bundle.devices.map((s, i) => {
    const noise = 1 + (((h + i * 29) % 19) - 9) / 100;
    return { ...s, sessions: Math.max(1, Math.round(s.sessions * noise)) };
  });
  const devSum = devicesRaw.reduce((a, s) => a + s.sessions, 0);
  const devices = devicesRaw.map((s) => ({
    ...s,
    sessions: Math.round((s.sessions / devSum) * 100),
  }));
  const devRoundDiff =
    100 - devices.reduce((a, s) => a + s.sessions, 0);
  if (devices.length) devices[0].sessions += devRoundDiff;

  const metrics = bundle.metrics.map((m, i) => {
    const salt = h + i * 31;
    return {
      ...m,
      value: perturbMetricDisplayString(m.value, salt),
      trend: clampTrend(m.trend + ((salt % 9) - 4)),
    };
  });

  return {
    trafficWeek,
    sources,
    devices,
    metrics,
  };
}

export function getAnalyticsBundleForPlanId(planId) {
  const variant = variantForPlanId(planId);
  const bundle = cloneBundle(variant);
  return perturbAnalyticsBundle(bundle, planId);
}

function planVolumeMultiplier(planId) {
  const h = hashPlanKey(planId);
  return 0.84 + ((h >>> 14) & 0x3f) / 95;
}

function countryVolumeWobble(planId, countryKey) {
  const h = hashPlanKey(`${planId}::${countryKey}`);
  return 0.78 + (h % 38) / 100;
}

function variantCountryWeight(variant, countryKey) {
  const m = VARIANT_GEO_WEIGHTS[variant];
  return m && m[countryKey] != null ? m[countryKey] : 1;
}

function planCountryAccent(planId, countryKey) {
  const h = hashPlanKey(`${planId}::geo::${countryKey}`);
  return 0.68 + (h % 52) / 100;
}

export function getGeoTrafficForPlanId(planId) {
  const variant = variantForPlanId(planId);
  const scale = GEO_SCALE[variant] ?? 1;
  const vol = planVolumeMultiplier(planId);
  const out = {};
  for (const [k, v] of Object.entries(BASE_GEO)) {
    const w =
      v *
      scale *
      vol *
      countryVolumeWobble(planId, k) *
      variantCountryWeight(variant, k) *
      planCountryAccent(planId, k);
    out[k] = Math.max(1, Math.round(w));
  }
  return out;
}

export function getPlanStableId(plan, fallbackIndex) {
  if (!plan) return "";
  let base = "";
  if (plan._id != null && plan._id !== "") base = String(plan._id);
  else if (plan.id != null && plan.id !== "") base = String(plan.id);
  else if (plan.projectId != null && plan.projectId !== "")
    base = String(plan.projectId);

  if (base === "") {
    return fallbackIndex != null ? `plan-${fallbackIndex}` : "";
  }

  if (fallbackIndex != null) {
    return `${base}#${fallbackIndex}`;
  }
  return base;
}
